import {USER_AUTH, APP_READY, SESSION} from "../storeConstants";

const initialState = {
    isLoggedIn: false,
    appReady: false,
}
export const appStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_AUTH:
            return {
                ...state,
                isLoggedIn: action.payload,
            }
        case APP_READY:
            return {
                ...state,
                appReady: action.payload,
            }
        default:
            return state;
    }
}

export const sessionReducer = (state = null, action) => {
    switch(action.type) {
        case SESSION:
            return action.payload;
        default:
            return state;
    }
}